export { default as cn } from 'clsx';

export function removeDuplicates(arr: any[]) {
  return [...new Set(arr)];
}

/** Money, to the cent. The epsilon is what stops 1.005 rounding down. */
export function round2(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function titleCase(str: string) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

/**
 * Whether a product's format — a sku's Term, a book's binding — is worth showing.
 * "Other" is the catch-all the catalogue gives a product with no format worth naming,
 * so every place a customer would read one leaves it out.
 */
export function isNamedFormat(format?: unknown): format is string {
  return typeof format === 'string' && format.trim() !== '' && format.trim().toUpperCase() !== 'OTHER';
}
